export enum EntityType {
  Client = 1,
  Contact = 2,
  Candidate = 3,
  Job = 4,
  Placement = 5,
  Submission = 6,
  User = 7,
  Opportunity = 8,
  Site = 9,
  Meeting = 10,
  Interview = 11,
  Email = 12,
  Activity = 13,
  Document = 14,
  Advert = 15,
  Application = 16,
  ChangeRequest = 17,
  EmailAddress = 18,
  OnboardingRequest = 19,
  ReferenceCheck = 20,
}
